import React, { useEffect, useMemo, useState } from 'react';
import styles from './NotificationListItem.module.scss';
import Avatar from '../../../../components/Avatar/Avatar';
import Icon from '../../../../components/Icon/Icon';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { getAvatarFromMessage, getMessageTitle } from '../../utils';
import { useHistory, useLocation } from 'react-router-dom';
import { stripHtmlTags } from '../../../../utils/stringHelper';

const NotificationListItem = ({
  message,
  selectedItems,
  setSelectedItems,
  setMessageDetails,
  setShowNotificationDetail,
  filterUnread,
  deleteMessage,
}) => {
  const [title, setTitle] = useState('');
  const [avatar, setAvatar] = useState(message?.metadata?.avatar);
  const { t } = useTranslation();
  const [hovering, setHovering] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const preparedBody = useMemo(() => stripHtmlTags(message.body), [message]);

  useEffect(() => {
    if (selectedItems?.some(({ id }) => id === message.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedItems]);

  useEffect(() => {
    setAvatar(getAvatarFromMessage(message));
    setTitle(getMessageTitle(message));
  }, [message]);

  const toggleMouseDown = () => {
    setHovering(true);
  };

  const toggleMouseLeave = () => {
    setHovering(false);
  };

  const handleDelete = () => {
    deleteMessage(message);
  };

  const onCardClick = () => {
    setMessageDetails(message);
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');
    history.push({
      pathname: location.pathname,
      search: `${type ? 'type=release_announcement&' : ''}id=${message.id}`,
    });
  };

  const getDateForm = () => {
    const currentDate = new Date();
    const currentDateHours = currentDate.getHours();
    const currentDateInMilliseconds = currentDate.getTime();
    const difference = currentDateInMilliseconds - message.publishedAt;

    var minutes = Math.floor(difference / 1000 / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var weeks = Math.floor(days / 7);
    var month = Math.floor(days / 30);
    var year = Math.floor(days / 360);

    if (year >= 1) {
      if (year === 1) {
        return `${t('notification.time.year', { date: year })}`;
      } else {
        return `${t('notification.time.years', { date: year })}`;
      }
    } else if (month >= 1) {
      if (month === 1) {
        return `${t('notification.time.month', { date: month })}`;
      } else {
        return `${t('notification.time.months', { date: month })}`;
      }
    } else if (weeks >= 1) {
      if (weeks === 1) {
        return `${t('notification.time.week', { date: weeks })}`;
      } else {
        return `${t('notification.time.weeks', { date: weeks })}`;
      }
    } else if (days >= 2) {
      return `${t('notification.time.days', { date: days })}`;
    } else if (hours - currentDateHours <= 24 && days >= 1) {
      // if it was yesterday but more than 24 hours ago
      return `${t('notification.time.yesterday')}`;
    } else if (hours >= 1) {
      if (hours === 1) {
        return `${t('notification.time.hour', { date: hours })}`;
      } else {
        return `${t('notification.time.hours', { date: hours })}`;
      }
    } else if (minutes >= 1) {
      return `${t('notification.time.minutes', { date: minutes })}`;
    } else {
      return `${t('notification.time.now')}`;
    }
  };

  const selectItem = () => {
    setIsSelected(!isSelected);
    if (!isSelected) {
      setSelectedItems(prevArray => [...prevArray, { id: message.id, read: message.read }]);
    } else {
      setSelectedItems(selectedItems.filter(({ id }) => id !== message.id));
    }
  };

  return (
    <div
      className={cx(styles.itemContainer, { [styles.isSelected]: isSelected })}
      onMouseMove={toggleMouseDown}
      onMouseLeave={toggleMouseLeave}
    >
      <div className={cx(styles.item, { [styles.newAnimationItem]: !message.read && !filterUnread })}>
        <div className={cx(styles.checkbox)} onClick={selectItem}>
          <input type="checkbox" id="myCheck" checked={isSelected} onChange={e => { }} aria-label={t('general.select')} />
        </div>

        <div className={cx(styles.wrapper)}>
          {!message.read ? (
            <Avatar image={avatar} title={!avatar ? message.sender : ''} size="large" className={styles.userAvatar} />
          ) : (
            <div className={cx(styles.checkAvatar)}>
              <Icon src="check" verticalAlign="middle" style={{ width: '24px', height: '24px' }} />
            </div>
          )}
          <div className={styles.contentWrapper} onClick={onCardClick}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.content}>{preparedBody}</p>
          </div>
          <div className={styles.actions}>
            <div className={styles.actionsWrapper}>
              <div className={styles.dateForm}>
                {!message?.read && <span className={styles.greenDot} />}
                <p>{getDateForm()}</p>
              </div>
              <div className={styles.trashIcon} onClick={handleDelete}>
                <Icon src="trash" verticalAlign="middle" style={{ width: '24px', height: '24px' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationListItem;
